export const priceFormatter = ({ value }: { value: number | null }) => {
  if (value == null) {
    return '–';
  }

  return `${value.toLocaleString()}₽`;
};
